// Sets the mobile subheader text based on selected nav tabs
$(document).on("turbo:load", ()=> {
  if ($(".subheader .subheader-toggle .header").length) {
    $(".subheader .subheader-toggle .header").html($(".subheader-nav-tabs li.active a").text());
    $(".subheader-nav-tabs li a").on("click", function() {
      $(".subheader .subheader-toggle .header").html($(this).text());
    });
  }
});
